import { IOrderExpiredReport } from '../types/orderExpiredReport';

import { changeToZeroMoment } from './timeHelpers';

export const groupOrderExpiredToCsv = (data: IOrderExpiredReport[]) => {
    //
    const groupData: any = [
        [
            'Order',
            'Order Name',
            'Case Number',
            'Student',
            'Service Type',
            'Case Number Validity To',
            'Amount Of Used Hours In Percent',
        ],
    ];
    data.forEach((it) => {
        const labelArr = [];
        if (it?.serviceType?.title) {
            labelArr.push(it.serviceType.title);
        }
        if (it?.serviceType?.cpt) {
            labelArr.push(`CPT: [${it.serviceType.cpt}]`);
        }
        const label = labelArr.join(', ');

        groupData.push([
            it.id ? it.id : '',
            it.name ? it.name : '',
            it.caseNumber ? it.caseNumber : '',
            it.student ? `${it.student.firstName} ${it.student.lastName}` : '',
            label,
            it.caseNumberValidityTo ? `${changeToZeroMoment(it.caseNumberValidityTo, 'MMM D, YYYY')}` : '',
            it.amountOfUsedHoursInPercent ? it.amountOfUsedHoursInPercent : '',
        ]);
    });

    return groupData;
};
